import { gql } from '@apollo/client';

export const login = gql`
  mutation login($loginInput: LoginInput!) {
    login(input: $loginInput) @client
  }
`;
